module.exports = __webpack_public_path__ + "fonts/Montserrat-LightItalic.3eb3e920.ttf";